export default __webpack_public_path__ + "static/media/NIAS0080.34I-32789_-17901_0.e2ca013c.jpg";